export default __webpack_public_path__ + "static/media/saiki_back.28d0335d.bmp";